import { render, staticRenderFns } from "./StudyOverview.vue?vue&type=template&id=503a241c&scoped=true&"
import script from "./StudyOverview.vue?vue&type=script&lang=ts&"
export * from "./StudyOverview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503a241c",
  null
  
)

export default component.exports